import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './WhyHostNew.css';
import cx from 'classnames';
import { flowRight as compose } from 'lodash';
import Scroll from 'react-scroll'; // Imports all Mixins

// Components
import WhyHostBanner from './WhyHostBanner';
import Loader from '../../components/Loader';
import HostingBlock from '../../components/WhyHost/HostingBlock/HostingBlock';
import CoverSection from '../../components/WhyHost/CoverSection/CoverSection';
import ImageBanner from '../../components/WhyHost/ImageBanner/ImageBanner';
import PaymentContent from '../../components/WhyHost/PaymentContent/PaymentContent';
import QuoteSection from '../../components/WhyHost/QuoteSection/QuoteSection';
import FaqSection from '../../components/WhyHost/FaqSection/FaqSection';

import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import getWhyHostReview from './getWhyHostReview.graphql';
import { withQuery } from '../../hoc/withGraphql';

let Element = Scroll.Element;

const WhyHostNew = (props) => {

  const { data: { loading, getWhyHostPage } } = props;
  const { getWhyHostReview: { getHomeWhyHostReview, loading: reviewLoading } } = props;
  let settingsCollection = {}

  if (loading && reviewLoading) {
    return <Loader type={"text"} loaderClass={'whyHostLoaderContainer'} />;
  }

  getWhyHostPage && getWhyHostPage.map((item, key) => {
    settingsCollection[item.name] = item.value
  });

  return (
    <div className={cx('whyhost-content', 'commonWordBreak')}>
      <WhyHostBanner data={settingsCollection} />
      <Element name="test1" className="element">
        <HostingBlock data={settingsCollection} />
        <CoverSection data={settingsCollection} />
        <ImageBanner data={settingsCollection} />
        {!reviewLoading && getHomeWhyHostReview && getHomeWhyHostReview.results && getHomeWhyHostReview.results.length > 0 && <PaymentContent data={settingsCollection} reviewData={getHomeWhyHostReview.results} />}
        <QuoteSection data={settingsCollection} />
        <FaqSection data={settingsCollection} />
      </Element>
    </div>
  );
}

WhyHostNew.propTypes = {
  title: PropTypes.string.isRequired,
};

export default compose(
  withStyles(s),
  withQuery(getWhyHostPageSettings, {
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  }),
  withQuery(getWhyHostReview, {
    name: "getWhyHostReview",
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  })
)(WhyHostNew);